export default {
    storagePattern: /(\d+)\.(\d+)\.?(\d+)*/,
}